import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import TableFeatures from "components/Outdoor_Cameras/IN-9808_QFHD/Product_Features/TableFeatures";
import TableStatus from 'components/Outdoor_Cameras/IN-9808_QFHD/Product_Features/TableStatus';
import NavButtons from "components/Outdoor_Cameras/IN-9808_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "IN-9808 4K (QFHD) Handbuch Produkteigenschaften",
  "path": "/Aussenkameras/IN-9808_QFHD/Produkt_Features/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die IN-9808 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS-Sensor verwendet.ilizing our new Sony 2160p / QFHD STARVIS sensor.",
  "image": "./P_SearchThumb_IN-9008HD_Features.png",
  "social": "/images/Search/P_SearchThumb_IN-9408WQHD_Features.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-9008HD_white.webp",
  "chapter": "Outdoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title="IN-9808 4K (QFHD) Handbuch Produkteigenschaften" dateChanged="2018-01-22" author="Mike Polinowski" tag="INSTAR IP Camera" description="Die IN-9808 4K (QFHD) ist die erste INSTAR IP-Überwachungskamera für den Außenbereich, die unseren neuen Sony 2160p / QFHD STARVIS-Sensor verwendet.ilizing our new Sony 2160p / QFHD STARVIS sensor." image="/images/Search/P_SearchThumb_IN-9408HD_Quick_Installation.png" twitter="/images/Search/P_SearchThumb_IN-9408HD_Quick_Installation.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Outdoor_Cameras/IN-9808_QFHD/Product_Features/" locationFR="/fr/Outdoor_Cameras/IN-9808_QFHD/Product_Features/" crumbLabel="Features" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "in-9808-4k-qfhd-handbuch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-9808-4k-qfhd-handbuch",
        "aria-label": "in 9808 4k qfhd handbuch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-9808 4K (QFHD) Handbuch`}</h2>
    <h3 {...{
      "id": "produktmerkmale",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#produktmerkmale",
        "aria-label": "produktmerkmale permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Produktmerkmale`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/2c568ff372ef906ae69905ebf87b5bb1/96e86/IN-9808QFHD_Product-Overview.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "83.47826086956522%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAA7rAAAO6wFxzYGVAAACnklEQVQ4y12UbW+bMBSF+f//aP3aD526Vqq2apXSVUsySEICxhj8hl/OdC+QRrUUQQw+nOvzXBc5ZxhjIPse1jmsg+Zvr8l7+FFf53g+ZyilMCqFdKqRRIei73tIKWHVAFFV0G0LGIOkDfIiHkKA1hq9lHwfY7x+2FoLZx2yscjeo+iEYIficoHte4i6BrxH0rObaZqgR82OUkos1nXd1XmvFAYpkesaSUoS7FhwHAboYQB9ACEg9f0s6BzPc6nWIS2CJE5jWNZRVdl5FGRZCIFBKTR1zQKIke2zhxgRQ8BoDNqyRJymqxgN2nspBFJ1QBICBU2O44iubaHJVUocwGTM4soim3k/gxDI08T3a8lxHBGX7ckpzYLkwFIQcf4yL1g2nu/XeEiE3OX8SQNVcxNSkW8e0ovZudlRWAQ5cc2Lovc4bXewnWRhdp/z1XFeBa8/SlFKxOORhZm/vkdoW2ZtaBr8fn2FbBqKH2kYZoc3bBb4Osix1p9gk2NCxxjeFns+Y1pTvyn1WjJxRbBScs459G0LU5/Z7exQIXUS3nu4aSKSP1eHAO8cY0T4kFaxkk+O9vs9nh++4+3pmQXI1d/NBr8eH3EoS4bYK8UdU5YlLnXNrUdixDJdWXAdh+qAny8veLi/x3bzzi5/PD3h290dLpcLqqrCx58P7LZbVGWJpmlgjWVR4lmPIwpqLXpAcB+PR5wOB/zbvEPs97DDgENVYbvZMPDOWsiu43epTHJJZwFxTM9ojkMxSqE9nWCs5U6YlEKk8oyBW7BJayU5I0wT6rrmLaKDxWjNnUYHSJHnEwCRFq4sEodEP6W4/ifuqIsomJtBYVK5tOecMneKcwgrCjkj1meE3W5GhggQHdKokdSARCcNia9n4hds/gNg9yh5zKC0ZAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2c568ff372ef906ae69905ebf87b5bb1/e4706/IN-9808QFHD_Product-Overview.avif 230w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/d1af7/IN-9808QFHD_Product-Overview.avif 460w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/7f308/IN-9808QFHD_Product-Overview.avif 920w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/22b88/IN-9808QFHD_Product-Overview.avif 1089w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/2c568ff372ef906ae69905ebf87b5bb1/a0b58/IN-9808QFHD_Product-Overview.webp 230w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/bc10c/IN-9808QFHD_Product-Overview.webp 460w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/966d8/IN-9808QFHD_Product-Overview.webp 920w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/37c82/IN-9808QFHD_Product-Overview.webp 1089w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/2c568ff372ef906ae69905ebf87b5bb1/81c8e/IN-9808QFHD_Product-Overview.png 230w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/08a84/IN-9808QFHD_Product-Overview.png 460w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/c0255/IN-9808QFHD_Product-Overview.png 920w", "/de/static/2c568ff372ef906ae69905ebf87b5bb1/96e86/IN-9808QFHD_Product-Overview.png 1089w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/2c568ff372ef906ae69905ebf87b5bb1/c0255/IN-9808QFHD_Product-Overview.png",
              "alt": "IN-9808 QFHD Produkt Features",
              "title": "IN-9808 QFHD Produkt Features",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <TableFeatures mdxType="TableFeatures" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "status-leds",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#status-leds",
        "aria-label": "status leds permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Status LEDs`}</h3>
    <TableStatus mdxType="TableStatus" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      